/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AttachmentsListDisplayComponent} from './attachments-list-display.component';
import {WarningsModule} from '../../../shared/warnings/warnings.module';
import {FileListModule} from '../../../shared/file-list/file-list.module';

@NgModule({
    declarations: [AttachmentsListDisplayComponent],
    imports: [
        CommonModule,
        WarningsModule,
        FileListModule

    ],
    exports: [AttachmentsListDisplayComponent]
})
export class AttachmentsListDisplayModule {
}
